import Vue from 'vue'
import Vuex from 'vuex'
import SecureLS from 'secure-ls'
import createPersistedState from 'vuex-persistedstate';
import system_data from './module/system'
import form_rules from './module/form_rules'
import authentication from './module/authentication'
import users from './module/user'
import transaction_months from './module/data/transaction_months'
import bank_depository from './module/data/bank_depository'
import deposit_slip from './module/data/deposit_slip'
import branch_information from './module/data/branch_information'
import transaction_months_history from './module/data/transaction_months_history'
import fund from './module/data/fund'
import fund_particulars from './module/data/fund_particulars'
import fund_liquidation from './module/data/fund_liquidation'
import client_information from './module/data/client_information'
import pera_padala from './module/data/pera_padala'
import teller_fund from './module/data/teller_fund'


const ls = new SecureLS({
  isCompression: false,
})
Vue.use(Vuex)

export default new Vuex.Store({
  plugins: [createPersistedState(
    {
      key: 'GL-REMITTANCES',
      paths: ['authentication'],
      storage: {
        getItem: (key) => ls.get(key),
        setItem: (key, value) => ls.set(key, value),
        removeItem: (key) => ls.remove(key),
      },
    },
  )],
  state: {},
  mutations: {},
  actions: {},
  modules: {
    system_data,
    form_rules,
    authentication,
    users,
    transaction_months,
    bank_depository,
    deposit_slip,
    branch_information,
    transaction_months_history,
    fund,
    fund_particulars,
    fund_liquidation,
    client_information,
    pera_padala,
    teller_fund,
  },
})
